// compliance pack initialization script
// TO DO, this is a temporary index version for testing the consent mode version of this SPA
// please do not replace the original one, instead, merge both when done
import fetchGeoLocation from 'global-utils/fetch-geo-loc';
import { loadCCIfShould, loadAGIfShould } from 'global-utils/load-conditions';
import { initGlobalFooter } from '@global-footer/init-global-footer';
import { isGlobalFooterEnabled } from 'config/env';
import { getScriptInfo, manageCookiesParam } from 'global-utils/get-attributes';
import { initGTM } from 'global-utils/GTM-utils';
import {
  isCookiesEnabled,
  isCookiesAllowed,
  removeOptionalConsentForDeniedAtt
} from 'global-utils/cookie-utils';
import {
  globalScope,
  initShopifyConsent,
  getShopifyVisitorConsent
} from 'global-utils/globals';
import { initCConsent } from 'global-utils/init-packages';

if (!isCookiesEnabled()) {
  console.warn('cbgCompPack: cookies are disabled, no cookies will be tracked');
}

const setLocation = async () => {
  const geoLocation = await fetchGeoLocation();
  const userLocation = geoLocation?.country?.isoCode;
  globalScope.userLocation = userLocation;
};

(async () => {
  loadAGIfShould();
  if (isGlobalFooterEnabled) {
    initGlobalFooter();
  }

  const reOpenConsent = () => {
    // if the cbgConsent script is not loaded, this reopenConsent function will be called
    // if it is, the reopenConsent inside the cbgConsent App component will be called instead
    initCConsent();
  };

  if (manageCookiesParam) {
    // if manageCookiesParam is true, we want to show the manage cookies screen on first load
    reOpenConsent();
  }

  const { checkCookies, isShopify } = getScriptInfo();
  globalScope.manageCookies = reOpenConsent;
  globalScope.getShopifyVisitorConsent = getShopifyVisitorConsent;

  if (isGlobalFooterEnabled) {
    document.addEventListener('click', (event) => {
      const target = event.target;
      const link =
        target instanceof Element
          ? target.closest(
              `a[href="${globalScope.global_footer.manageCookies.url}"]`
            )
          : null;

      if (link) {
        event.preventDefault();
        globalScope.manageCookies();
      }
    });
  }

  // only trigger GTM related events if the cookies package is supposed to be used
  // 1 - load GTM on plugin load if not in dev or tst environment - stable version
  // 2 - tst version - load GTM on plugin load only if optional consent previously granted
  if (checkCookies) {
    // Remove optional consent if Att is denied, this is to make sure that if the user previously granted optional consent,
    // but now has it denied, we remove the optional consent to avoid tracking without consent
    removeOptionalConsentForDeniedAtt();

    if (isCookiesAllowed()) {
      // add GTM container script to the page head
      initGTM();
    }
  }

  if (isShopify && checkCookies) {
    initShopifyConsent();
  }

  loadCCIfShould();

  setLocation();
})();
